"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichText = exports.Typography = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classNames_1 = require("../../../utils/classNames");
const theme_1 = require("../../../utils/theme");
const MAX_LENGHT_CHARACTERS = 280;
exports.Typography = (0, react_1.forwardRef)((props, ref) => {
    const { children, className, gutterBottom, invert, tagName, uppercase, variant, contrastType, palette = 'none', letterSpacing, weight, align, color, opacity = 0, readMore, ...remaining } = props;
    const theme = (0, theme_1.useTheme)();
    const computeOpacity = () => {
        if (opacity === 0)
            return theme.palette[palette]['text'];
        const _color = color || theme.palette[palette]['text'];
        return [_color + `/${opacity}`];
    };
    const colorBaseClassName = [palette ? computeOpacity() : undefined];
    const baseClassName = (0, classNames_1.cn)(invert && 'invert', uppercase && 'uppercase', ...theme.typography.gutterBottom[gutterBottom || 'none'], ...theme.typography.variants[variant || 'body'], colorBaseClassName, color && `text-${color}`, className);
    const [showAll, setShowAll] = (0, react_1.useState)(false);
    if (typeof children === 'string')
        return (0, react_1.createElement)(tagName || 'span', {
            ref,
            className: baseClassName,
            ...remaining,
        }, readMore ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(exports.RichText, { text: showAll
                            ? children
                            : children.toString().slice(0, MAX_LENGHT_CHARACTERS) + '...' }) }), children.toString().length > MAX_LENGHT_CHARACTERS && ((0, jsx_runtime_1.jsx)("span", { onClick: () => setShowAll(!showAll), className: "cursor-pointer font-bold uppercase underline", children: showAll ? 'Read less' : 'Read more' }))] })) : ((0, jsx_runtime_1.jsx)(exports.RichText, { text: children })));
    return (0, react_1.createElement)(tagName || 'span', {
        className: baseClassName,
        ...remaining,
    }, (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }));
});
const RichText = (props) => {
    const { text } = props;
    String.prototype.parseLiElement = function () {
        return this.replace(/(<li>)(.*?)(<\/li>)/g, "<li class='ml-4 list-disc'>$2</li>");
    };
    String.prototype.parseStrongElement = function () {
        return this.replace(/(<strong>)(.*?)(<\/strong>)/g, "<strong class='font-strong'>$2</strong>");
    };
    String.prototype.parseULElement = function () {
        return this.replace(/(<ul>)(.*?)(<\/ul>)/g, "<ul class='py-2'>$2</ul>");
    };
    return ((0, jsx_runtime_1.jsx)("span", { suppressHydrationWarning: true, dangerouslySetInnerHTML: {
            __html: text.parseLiElement().parseStrongElement().parseULElement(),
        } }));
};
exports.RichText = RichText;
